import { RouteInfo } from "common/routes/route.types";
import { usePermissionsChecker } from "core/auth/Permissions";
import { NavBarNavItemProps } from "layout/nav-bar/components/NavbarNavItem";
import { navBarActionButtonStyles } from "layout/nav-bar/nav-bar.styles";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

import {
  ActionButton,
  ActionButtonProps,
  IContextualMenuItem,
  useTheme
} from "@bps/fluent-ui";

interface NavMenuButtonProps
  extends Omit<NavBarNavItemProps, "tab" | "to">,
    ActionButtonProps {
  items: RouteInfo[];
  isCurrent: boolean;
}

export const NavMenuButton: FC<NavMenuButtonProps> = ({
  items,
  iconName,
  isCurrent,
  ...buttonProps
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const hasPermissions = usePermissionsChecker();

  const menuItems = items.reduce((acc, curr) => {
    if (!hasPermissions(curr.permissions, curr.permissionsOperator)) {
      return acc;
    }

    //add new item
    const items = [...acc];

    const newItem = {
      key: curr.path,
      text: curr.text,
      onClick: () => navigate(curr.path)
    };
    items.push(newItem);
    return items;
  }, [] as IContextualMenuItem[]);

  if (!menuItems.length) {
    return null;
  }

  return (
    <ActionButton
      iconProps={{ iconName }}
      styles={navBarActionButtonStyles(theme, isCurrent)}
      menuProps={{
        items: menuItems
      }}
      {...buttonProps}
    />
  );
};
